export const it_idealista= {

    'bread_title' : 'Idealista',
    'label_region': 'Regione',
    'label_city' : 'Città',
    'label_hasLift' :'Ascensore',
    'label_bathroom' :'Bagni',
    'label_rooms' :'Vani',
    'label_mq' :'Fino a mq',
    'label_price' :'Prezzo',
    'label_zone' : 'Zone',
    'label_min_price': 'Prezzo min',
    'label_max_price': 'Prezzo max',
};